import axios from 'axios';

//here is where we are defining our custom axios instance.
//if all of your API routes come from the same location, or you are using a web proxy to hit the server, you can provide a base url
//you can also attach axios interceptors to custom axios instances as well
const apiClient = axios.create({
  baseURL: "https://orthophoto-viewer-backend.herokuapp.com"
  // baseURL: 'http://localhost:4000'
})
axios.defaults.withCredentials = true 

// // DEVDEVDEV TO LOG REQUESTS
// apiClient.interceptors.request.use(request => {
//   console.log("blah")
//   console.log('Starting Request', JSON.stringify(request, null, 2))
//   return request
// })


// apiClient.interceptors.response.use(response => {
//   console.log('Response:', JSON.stringify(response, null, 2))
//   return response
// })
// // /DEVDEVDEV

// req_interceptor is the function that will add 
// an auth token in every request
// the auth token is stored in the memory of this react app
// it is directly accessible by no function (local variable of function)
let req_interceptor = undefined;
let token = ''

// the session logic
let response_interceptor = (error) => {
  if (error.config && error.response && error.response.status === 401) {
    // a request failed, that's probably becaus of an expired token
    // let's get a new auth token
    return apiClient.post('/refresh', {
      csrf: localStorage.getItem('csrf')      
    },{
      withCredentials: true
    })
    .then((response) => {
      // we have the new token
      update_auth_token({
        auth_token: response.data.auth_token,
        csrf_token: response.data.csrf_token
      })
      // put the new token
      error.config.headers.auth = response.data.auth_token
      // retry the request
      return apiClient.request(error.config);
    })
    .catch((error) => {
      // this doesn't work, we are not authenticated anymore
      req_interceptor = undefined;
      // Do something with request error
      return Promise.reject(error);
    });
  }else{
    return Promise.reject(error);
  }
}

let request_interceptor = (auth_token) => {
  return (config) => {
    // set auth
    config.headers.auth = auth_token
    // continue
    return config
  }
}

let update_auth_token = ({auth_token,csrf_token}) => {
  apiClient.interceptors.response.use(response => response, response_interceptor);
  if(req_interceptor !== undefined) { 
    apiClient.interceptors.request.eject(req_interceptor) 
  }
  if(auth_token !== ''){
    req_interceptor = apiClient.interceptors.request.use(request_interceptor(auth_token), (error) => {
      // Do something with request error
      return Promise.reject(error);
    })
    token = auth_token
  }
  // set csrf token in localStorage
  localStorage.setItem('csrf', csrf_token);
};

export default {
  req: (graphql_request) => {
    return apiClient.post('/graphql', { query: graphql_request }, {withCredentials: true})
  },
  // GraphQL request as a standard JSON API: the returned value is a parsed JSON of the HTTP response body
  // without all the axios overhead
  req_as_standard: async (graphql_request) => {
    const axios_resp = await apiClient.post('/graphql', { query: graphql_request }, {withCredentials: true});
    return axios_resp.data;
  },
  dxf_export: (payload) => {
    return apiClient.post(`/dxf_export?token=${token}`, payload, {withCredentials: true})
  },
  create_user_event: ({userId, category, other_infos}) => {
    if (token == ""){
      throw new Error("Can't send a user_event, not authenticated!");
    }
    else{
      const graphql_request = `mutation {
        createUserEvent(user_event: {
          userId: "${userId}", 
          category: "${category}",
          other_infos: ${JSON.stringify(JSON.stringify(other_infos))}
        })
      }`
      return apiClient.post('/graphql', { query: graphql_request }, {withCredentials: true})
    }
  },
  refresh: (payload) => {
    
    return new Promise((resolve,reject) => {
      // try to login
      apiClient.post('/refresh',{
        csrf: localStorage.getItem('csrf')
      },{
        withCredentials: true
      })
      .then((response) => {
        update_auth_token({
          auth_token: response.data.auth_token,
          csrf_token: response.data.csrf_token
        })
        resolve({
          auth_token: response.data.auth_token,
          user_id: response.data.user_id
        })
      })
      .catch(reject);
    }) 
  },
  authenticate: (payload) => {
    return new Promise((resolve,reject) => {
      apiClient.post('/authenticate',payload,{ withCredentials: true })
      .then((response) => {
        update_auth_token({
          auth_token: response.data.auth_token,
          csrf_token: response.data.csrf_token
        })
        resolve({
          auth_token: response.data.auth_token,
          user_id: response.data.user_id
        })
      })
      .catch((error) => {
        console.log(error)
        reject(error)
      })
    })
  },
  logout: () => {
    return new Promise((resolve,reject) => {
      apiClient.post('/logout',{},{withCredentials:true})
      .then((response) => {
        update_auth_token({
          auth_token: '',
          csrf_token: ''
        })
        token = ""; // Clear auth_token locally
        resolve()
      })
      .catch(reject)
    })
  },
  clearAuth: () => {
    update_auth_token({
      auth_token: '',
      csrf_token: ''
    });
    token = ""; // Clear auth_token locally
  },
  getAuthToken: () => {
    return token
  }
}